<template>
  <div>
    <template v-if="loading">
      <v-row :align="'center'" justify="center" style="height: 75vh">
        <div class="text-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
    pdfFile() {
      return this.query.file;
    },
  },
  mounted() {
    if (this.pdfFile) {
      this.handleDownload();
    }
  },
  methods: {
    async handleDownload() {
      try {
        await this.$liff.openWindow({
          url: this.pdfFile,
          external: true,
        });

        setTimeout(() => {
          this.$liff.closeWindow();
        }, 500);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
